let React   = require('react');
let mui     = require('material-ui');
let Reflux  = require('reflux');
let Actions = require('../actions');

let Colors = mui.Styles.Colors;
let Dialog = mui.Dialog;

let PasswordDialog = React.createClass({

  render () {
    return <div />;
  },

});

module.exports = PasswordDialog;



/** WEBPACK FOOTER **
 ** ./src/app/components/password_dialog.jsx
 **/